import { useQuery } from "@tanstack/react-query";
import { fetchCategoryOptions } from "../api/fetchCategoryOptions";

export const useCategoryOptions = () => {
  const { data, error, isLoading, refetch } = useQuery({
    queryKey: ["categoryOptions"],
    queryFn: fetchCategoryOptions,
  });

  return {
    data: data?.result || [],
    error,
    isLoading,
    refetch,
  };
};

